import { createSelector } from "reselect";

const getStory = (state) => state.story;

export default createSelector(getStory, (story) => ({
  ...story.entities.automaticHotspot,
  ...story.entities.tagHotspot,
  ...story.entities.invisibleHotspot,
}));
